
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17.396 17.195c-.273-.366-.652-.695-1.108-.695H7.712c-.456 0-.835.329-1.108.695A1.997 1.997 0 015 18c-.657 0-1.24-.317-1.604-.805-.273-.366-.652-.695-1.108-.695H2a1 1 0 01-1-1v-3.317c0-.377.306-.683.683-.683a.683.683 0 00.522-.242L7.2 5.354A1 1 0 017.964 5H22a1 1 0 011 1v9.5a1 1 0 01-1 1h-.288c-.456 0-.835.329-1.108.695A1.997 1.997 0 0119 18c-.657 0-1.24-.317-1.604-.805zM6.35 8.17l-2.625 3a.5.5 0 00.376.829H7.5a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5h-.773a.5.5 0 00-.376.17zM10.5 8a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z","fill":"currentColor"}})])
          )
        }
      }
    